export const pages = {
	'linkOutMY': { id: 'linkOutMY', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
